import { effectiveTierValueType } from '@/components/ui/OfferProductPreview';
import type { DiscountConfig, OfferType } from '@/types/BrandOffer.types';
import { BRAND_OFFER_DETAIL_BASE } from '../BrandOffersPage.constants';

export function discountSummary(
  dc: DiscountConfig | null,
  offerType: OfferType
): string | null {
  if (!dc) return null;
  if (dc.type === 'FLAT' && dc.value) return `₹${dc.value} flat off`;
  if (dc.type === 'PERCENT' && dc.value) return `${dc.value}% off`;
  if (dc.type === 'TEXT' && dc.offerText) return dc.offerText;
  if (dc.type === 'TIER' && dc.rules?.length) {
    const tiers = dc.rules
      .map((r) => {
        const k = effectiveTierValueType(r, offerType);
        return k === 'PERCENT' ? `${r.value}%` : `₹${r.value}`;
      })
      .join(' · ');
    return `${dc.rules.length} tiers (${tiers})`;
  }
  return null;
}

export function formatEndDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function brandOfferDetailPath(offerId: number): string {
  return `${BRAND_OFFER_DETAIL_BASE}/${offerId}`;
}

export function formatBulkSelectionCount(count: number): string {
  const noun = count === 1 ? 'row' : 'rows';
  return `${count} ${noun} selected`;
}

export function formatPaginationSummary(
  rangeStart: number,
  rangeEnd: number,
  totalCount: number
): string {
  return `Showing ${rangeStart}–${rangeEnd} of ${totalCount}`;
}

export function formatPageIndicator(page: number, totalPages: number): string {
  return `Page ${page} / ${totalPages}`;
}
